import { render, staticRenderFns } from "./quote-detail-results.vue?vue&type=template&id=c8310bec"
import script from "./quote-detail-results.vue?vue&type=script&lang=js"
export * from "./quote-detail-results.vue?vue&type=script&lang=js"
import style0 from "./quote-detail-results.vue?vue&type=style&index=0&id=c8310bec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports